import type { RouteObject } from "react-router-dom";

/*
  The Review view of the 2026-11-03 design (rebuild package 4.1F). It loads when it is first opened, so its panes and style sheet are
  not part of the first download. Who may open the address is in `app/screens.ts`; it is not repeated here.
*/

export const routes: RouteObject[] = [{ path: "/review", lazy: async () => ({ Component: (await import("./ReviewView")).ReviewView }) }];
